





































import {Component, Prop, Vue} from "vue-property-decorator";
import {UnitSystem} from "@/interfaces/units";
import CriticalLocationLayoutInspector
  from "@/modules/perRoad/views/components/inspection/CriticalLocationLayoutInspector.vue";
import {
  IPrSimulatedLayerImperial,
  IPrSimulatedLayerMetric,
  IPrTireLoadImperial,
  IPrTireLoadMetric,
  IWesleaConfig,
  IWesleaResult
} from "@/modules/perRoad/interfaces/monteCarlo";
import {getPeakHorizontalStrain} from "@/modules/perRoad/lib/calculations/horizontalStrainDistribution";
import {IPavementStructureScenarioImperial} from "@/modules/structure/interfaces/pavementStructure";
import {getResultItems} from "@/modules/structure/lib/evaluateResults";

Component.registerHooks(["validations"]);

@Component({
  components: {
    CriticalLocationLayoutInspector,
  },
})
export default class ResultsOverview extends Vue {

  @Prop() id!: string;

  @Prop() scenario!: IPavementStructureScenarioImperial;

  @Prop() simulatedLayers!: IPrSimulatedLayerImperial[] | IPrSimulatedLayerMetric[];

  @Prop() loads!: IPrTireLoadMetric | IPrTireLoadImperial;

  @Prop() wesleaConfig!: IWesleaConfig[];

  @Prop() wesleaResults!: IWesleaResult[];

  @Prop({default: 0}) externalPlotKey!: number;

  get isImperial() {
    return this.simulatedLayers[0].unitSystem === UnitSystem.Imperial;
  }

  get horizStrain() {
    return getPeakHorizontalStrain(this.wesleaResults.filter(r => r.layer === 1 && r.location.z > 0));
  }

  get fatigueLimit() {
    return (this.scenario.fatigueParamA * (10 ** (-6))) * ((1 / Math.abs(this.horizStrain)) ** (this.scenario.fatigueParamB));
  }

  get peakDeflection() {
    return;
  }

  get ruttingLimit() {

    return null;
  }

  get peakStrain() {
    return getPeakHorizontalStrain(this.wesleaResults);
  }

  // get peakResults(): { [index: string]: IWesleaResult[] } {
  //   /**
  //    * xStrain
  //    */
  //   const normalStrainTensionX = this.wesleaResults.filter(r => r.layer === 1 && r.location.z > 0).map(result => result.normal_strain.x);
  //   const maxXStrainTension = Math.min(...normalStrainTensionX);
  //   // console.log("Max X Strain", maxXStrainTension);
  //   const xResults = this.wesleaResults.filter(result => result.normal_strain.x === maxXStrainTension);
  //
  //   /**
  //    * yStrain
  //    */
  //       // const normalStrainTensionY = this.wesleaResults.map(result => result.normal_strain.y);
  //   const normalStrainTensionY = this.wesleaResults.filter(r => r.layer === 1 && r.location.z > 0).map(result => result.normal_strain.y);
  //   const maxYStrainTension = Math.min(...normalStrainTensionY);
  //   // console.log("Max Y Strain", maxYStrainTension);
  //   const yResults = this.wesleaResults.filter(result => result.normal_strain.y === maxYStrainTension);
  //
  //   /**
  //    * Displacement
  //    */
  //
  //   const deflectionZ = this.wesleaResults.map(result => result.deflection.z);
  //   const maxDeflectionZ = Math.max(...deflectionZ);
  //   // console.log("Max Y Strain", maxDeflectionZ);
  //   const deflectionZResults = this.wesleaResults.filter(result => result.deflection.z === maxDeflectionZ);
  //
  //
  //   return {
  //     strain_x: xResults,
  //     strain_y: yResults,
  //     deflection_z: deflectionZResults
  //   };
  //
  //
  // }

  sync() {
    this.incrementPlotKey();

  }

  get items() {
    return getResultItems(this.wesleaResults, this.wesleaConfig, this.simulatedLayers, this.scenario);
  }

  get fields() {
    return [
      "layer",
      {key: "type", label: "Material"},
      "x",
      "y",
      "z",
      "horizStrain",
      "verticalStrain",
      "fatigueLoads",
      "ruttingLoads",
    ];
  }

  internalPlotKey = 0;

  get plotKey() {
    return this.internalPlotKey + this.externalPlotKey;
  }

  incrementPlotKey() {
    this.internalPlotKey += 1;
  }

}

